import { apiSlice } from "../apiSlice";
import { TEACHERS_URL } from "../../constants";

export const teacherApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      loginTeacher: builder.mutation({
        query: (data) => ({
          url: `${TEACHERS_URL}/login`,
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Questions'], 
      }),
      registerTeacher: builder.mutation({
        query: (data) => ({
          url: `${TEACHERS_URL}/register`,
          method: 'POST',
          body: data,
        }),
      }),
      logoutTeacher: builder.mutation({
        query: () => ({
          url: `${TEACHERS_URL}/logout`,
          method: 'POST',
        }),
        invalidatesTags: ['Questions'],
      }),
      publicprofileTeacher: builder.query({
        query: (id) => ({
          url: `${TEACHERS_URL}/publicprofile/${id}`,
        }),
      }),
      publicTeacherimage: builder.query({
        query: (id) => ({
          url: `${TEACHERS_URL}/publicteacherimage/${id}`,
        }),
        invalidatesTags: ['plans'],
      }),
      profileTeacher: builder.mutation({
        query: (data) => ({
          url: `${TEACHERS_URL}/profile`,
          method: 'PUT',
          body: data,
        }),
      }),
      TeacherAllStudents: builder.query({
        query: () => ({
            url: `${TEACHERS_URL}/teacherallstudents`,
        }),
        providesTags: ['Teachers'],

    }),

    }),
});

export const { 
  useLoginTeacherMutation, 
  useLogoutTeacherMutation, 
  useRegisterTeacherMutation,
  useProfileTeacherMutation,
  usePublicprofileTeacherQuery,
  usePublicTeacherimageQuery,
  useTeacherAllStudentsQuery
} = teacherApiSlice;
